import { RequestQueryParamsModel } from "../http.interface";

export class BranchWarehouseParams implements RequestQueryParamsModel {
  limit: number | undefined;
  page: number | undefined;
  search: string | undefined;
  sorts: string | undefined;
  byUser = false;
}
